import { IMSObject, IMSId } from './ims-object';

/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190402 by Jan Brunner
 *     all rights reserved.
 */



export enum EMP_IMSAPPSTATUS {
  ACTIVE = "iasActive",
  PASSIVE = "iasPassive",
}

export class Employee extends IMSObject {
  static fromDto(dto: EmployeeDTO, databag?: any) {
    const obj = new this(
      {
        imsId: dto.id,
        secondaryId: dto.secondaryid,
        objRef: 'ims/Employee'
      },
      dto.label,
      dto.name,
      dto.lastname,
      dto.imsappstatus,
      dto.primarycar && dto.primarycar.id
        ? new IMSObject(
            dto.primarycar.id,
            undefined,
            dto.primarycar.label,
            'ims/Car'
          )
        : undefined,
      dto.employmenttype && dto.employmenttype.id
        ? new IMSObject(
            dto.employmenttype.id,
            undefined,
            dto.employmenttype.label,
            'ims/EmployeeType'
          )
        : undefined,
      dto.tag,
      dto.appusername,
      dto.assignedsvemp && dto.assignedsvemp.id
        ? new IMSObject(
            dto.assignedsvemp.id,
            undefined,
            dto.assignedsvemp.label,
            'ims/Employee'
          )
        : undefined,
    );

    if (databag) {
      obj.databag = databag;
    } else {
      obj.databag = dto;
    }
    return obj;
  }

  public get primarycellphonephonenumber(): string {
    return (
      this.databag.primarycellphonephonenumber ??
      this.databag.primarycellphonephonenumber_imsapp ??
      this.databag.primarycellphonephonephonenumber
    );
  }

  public get email(): string {
    return this.databag.email;
  }

  constructor(
    public readonly id: IMSId,
    label: string,
    public name: string,
    public lastname: string,
    public imsappstatus: string,
    public primarycar: IMSObject,
    public employmenttype: IMSObject,
    public tag: string,
    public appusername: string,
    public assignedSvEmp: IMSObject
  ) {
    super(id.imsId, id.secondaryId, label, 'ims/Employee');
  }
}

export interface EmployeeDTO {
  id: number;
  secondaryid: number;
  label: string;
  name: string;
  imsappstatus: string;
  primarycar: {
    id: number;
    label: string;
  };
  employmenttype: {
    id: number;
    label: string;
  };
  tag: string;
  lastname: string;
  appusername: string;
  assignedsvemp: {
    id: number;
    label: string;
  };
}
